// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2mEJg","calendarButtons":"ClockData_calendarButtons__2oiRK"};